<!-- Gemello del dialog dei Termini e Condizioni (condivide il suo SCSS): stessa
     veste, ma qui non c'e' nessun consenso da raccogliere - il preventivo non
     parte verso lo SDI - quindi niente riquadro della spunta e conferma sempre
     attiva.
     Titolo, contenuto e fascia delle azioni sono figli DIRETTI della
     superficie: e' la condizione perche' la fascia panna resti a filo del
     bordo inferiore. -->
<h2 mat-dialog-title>Conferma</h2>

<mat-dialog-content>
  <p class="izy-terms-message">Confermi la creazione del preventivo?</p>
</mat-dialog-content>

<mat-dialog-actions align="end" class="izy-dialog-actions">
  <button
    mat-stroked-button
    type="button"
    mat-dialog-close
    class="izy-button-ghost custom-button-border">
    <mat-icon>arrow_back</mat-icon>
    Indietro
  </button>

  <button
    matButton="filled"
    type="button"
    (click)="confirm()"
    class="ms-2 izy-button-primary custom-button-border">
    <mat-icon>check</mat-icon>
    Confermo
  </button>
</mat-dialog-actions>
